// User-facing dates/times are business-anchored to America/Panama.
const TZ = 'America/Panama';

const loc = (locale) => ((locale || 'es').startsWith('en') ? 'en-US' : 'es-PA');

export const fmtDatePA = (iso, locale = 'es') => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat(loc(locale), {
      timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric',
    }).format(new Date(iso));
  } catch { return '—'; }
};

export const fmtDateTimePA = (iso, locale = 'es') => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat(loc(locale), {
      timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    }).format(new Date(iso));
  } catch { return '—'; }
};
